<template>
  <div class="dimed wrap">
    <div class="layer layer--sm">
      <div class="layer__body">
        <div class="ft--xlg ft--bold" v-if="type == 'A'">{{ $t('Modal.AlramConfirm.msg1') }}</div>
        <div class="ft--xlg ft--bold" v-if="type == 'P'">{{ $t('Modal.AlramConfirm.msg2') }}</div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="$emit('setNext')">{{ $t('Modal.AlramConfirm.msg3') }}</button>
        <button class="btn btn--submit" @mouseup="$emit('setRetry')">{{ $t('Modal.AlramConfirm.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'alramConfirm',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {
    type: String,
  },
  methods: {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
